import axios from "axios";
import { Base_URL } from "../url";

export const saveExternalSystem = async (externalSystemData, userName = "defaultUser") => {
  try {
    const response = await axios.post(
      `${Base_URL}/ExternalSystem/CreateExternalSystem?UserName=${userName}`,
      {
        externalCode: externalSystemData.externalCode,
        description: externalSystemData.description
      }
    );
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving external system!";
  }
};

export const getAllExternalSystems = async () => {
  try {
    const response = await axios.get(`${Base_URL}/ExternalSystem/GetAllExternalSystems`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching external systems!";
  }
};